import React from 'react'

function Loader({ className = 'mirs-overlay', text = "Loading..." }) {

    return (
        <>
            <div className={className}></div>
            <div className="center">
                <div className="loader">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div className='loader-text'>{text}</div>
            </div>
        </>
    );
}


export default Loader



